import {
  Dashboard as H2ODashboard,
  DashboardRowLayout,
  dashboardStylesSmallGap,
  IDashboardProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Sizes,
  useClassNames,
} from '@h2oai/ui-kit';
import { useHistory } from 'react-router-dom';

import { PendingPermissionsWidget } from '../../../components/PendingPermissionsWidget/PendingPermissionsWidget';
import { PinnedFeatureSetListWidget } from '../../../components/PinnedFeatureSetListWidget/PinnedFeatureSetListWidget';
import { PopularFeatureSetListWidget } from '../../../components/PopularFeatureSetListWidget/PopularFeatureSetListWidget';
import { RecentlyOpenedListWidget } from '../../../components/RecentlyOpenedListWidget/RecentlyOpenedListWidget';
import { SearchAll } from '../../../components/SearchAll/SearchAll';
import { SummaryCardListWidget } from '../../../components/SummaryCardListWidget/SummaryCardListWidget';
import { ContentsTitle } from '../../../featurestore/models';
import { featurestorePageClassName } from '../../../featurestore/styles';
import { RoutePaths } from '../../../pages/Routes';
import { dashboardStylesDefault, IDashboardClassNames, IDashboardStyles } from './Dashboard.styles';

enum WidgetID {
  Summary = 'Summary',
  MostPopular = 'MostPopular',
  PinnedFeatureSets = 'PinnedFeatureSets',
  RecentlyOpened = 'RecentlyOpened',
  PendingPermissions = 'Pending Permissions',
}

export const Dashboard = () => {
  const history = useHistory();
  const dashboardProps: IDashboardProps = {
    styles: dashboardStylesSmallGap,
    title: '',
    showControls: false,
    rows: [
      {
        height: 71,
        layout: DashboardRowLayout.one,
        widgetIds: [WidgetID.Summary],
      },
      {
        height: 323,
        layout: DashboardRowLayout.twoOne,
        widgetIds: [WidgetID.MostPopular, WidgetID.PinnedFeatureSets],
      },
      {
        height: 425,
        layout: DashboardRowLayout.twoOne,
        widgetIds: [WidgetID.PendingPermissions, WidgetID.RecentlyOpened],
      },
    ],
    cellRenderer: (widgetId: string) => {
      switch (widgetId) {
        case WidgetID.Summary:
          return <SummaryCardListWidget />;
        case WidgetID.MostPopular:
          return <PopularFeatureSetListWidget />;
        case WidgetID.PinnedFeatureSets:
          return <PinnedFeatureSetListWidget />;
        case WidgetID.RecentlyOpened:
          return <RecentlyOpenedListWidget />;
        case WidgetID.PendingPermissions:
          return <PendingPermissionsWidget />;
        default:
          return null;
      }
    },
  };
  const classNames = useClassNames<IDashboardStyles, IDashboardClassNames>(
    'Dashboard',
    dashboardStylesDefault,
    undefined,
    featurestorePageClassName
  );
  return (
    <div className={classNames.root}>
      <PageHeader
        style={{ marginBottom: Sizes.padding }}
        styles={pageHeaderStylesSecondary}
        pageTitle="Home"
        breadcrumbProps={{
          items: [
            {
              text: ContentsTitle.home,
              key: ContentsTitle.home,
              onClick: () => history.push(RoutePaths.ROOT),
            },
            {
              text: ContentsTitle.dashboard,
              key: ContentsTitle.dashboard,
              isCurrentItem: true,
              style: { padding: 0 },
            },
          ],
        }}
        secondaryContents={<SearchAll />}
      />
      <H2ODashboard {...dashboardProps} />
    </div>
  );
};
